// extracted by mini-css-extract-plugin
export default {"loader":"general_loader__Zb6FN","custom_scroll_y":"general_custom_scroll_y__E97qt"};